import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityDataAccessSearchSlice } from './get';

import {
	coreDataSecurityDataAccessSearchHistoryReducers,
	coreDataSecurityDataAccessSearchHistoryWatchers
} from './history';
import { coreDataSecurityDataAccessSearchUserReducers, coreDataSecurityDataAccessSearchUserWatchers } from './users';

export const coreDataSecurityDataAccessSearchReducers = combineReducers({
	get: getCoreDataSecurityDataAccessSearchSlice.asyncReducers,
	history: coreDataSecurityDataAccessSearchHistoryReducers,
	users: coreDataSecurityDataAccessSearchUserReducers
});

export const coreDataSecurityDataAccessSearchWatchers = combineAllWatchers([
	getCoreDataSecurityDataAccessSearchSlice.asyncWatchers,
	coreDataSecurityDataAccessSearchHistoryWatchers,
	coreDataSecurityDataAccessSearchUserWatchers
]);
